import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { privacyPolicy, termsOfService, type LegalDocument } from '../../data/legal';
export function SiteFooter() {
  const [openDoc, setOpenDoc] = useState<LegalDocument | null>(null);
  return <footer className="bg-ink py-12 pb-28" data-id="element-125" data-mp="3te2xdrj2fcrl">
      <div className="mx-auto w-full max-w-5xl px-6" data-id="element-126" data-mp="3oguetpu096pt">
        <p className="font-display text-2xl text-gold-soft" data-id="element-127" data-mp="3oezq00fm4ugg">Curly Seducción</p>
        <p className="mt-3 max-w-prose text-xs leading-relaxed text-sand/70" data-id="element-128" data-mp="30s1cnbmsi2mr">
          Los resultados varían según el tipo de cabello, la constancia y el estado inicial del
          rizo. Este material es educativo y no sustituye la valoración de un profesional
          dermatológico o capilar.
        </p>

        <div className="mt-6 flex flex-wrap items-center gap-x-6 gap-y-2 border-t border-white/10 pt-6 text-xs text-sand/70" data-id="element-129" data-mp="35p9vlefriap2">
          <button type="button" onClick={() => setOpenDoc(privacyPolicy)} className="underline-offset-4 transition-colors duration-150 ease-out hover:text-cream hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-130" data-mp="2d1xbdax2qeyx">
            Política de Privacidad
          </button>
          <button type="button" onClick={() => setOpenDoc(termsOfService)} className="underline-offset-4 transition-colors duration-150 ease-out hover:text-cream hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-gold/50" data-id="element-131" data-mp="3m6y81lew8xxs">
            Términos del Servicio
          </button>
          <span data-id="element-132" data-mp="33f5g7ubk9irn">© {new Date().getFullYear()} Curly Seducción</span>
        </div>
      </div>

      <LegalModal document={openDoc} onClose={() => setOpenDoc(null)} data-id="element-133" data-mp="33hi7iy37l5hd" />
    </footer>;
}